/**
 * Global Imports
*/

import React from 'react';

/**
 * Local Imports
*/

import { Box } from './Box';

/**
 * Exports
*/

/**
 * 
 */
export function Breadcrumbs(props) {
  return (
    <Box className='mb-4'>
      { props.children }
    </Box>
  );
}